import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Button, Glyphicon } from '@bingads-webui-react/primitive';

export default class ButtonBack extends PureComponent {
  render() {
    return (
      <Button
        className={`button-back ${this.props.className}`}
        aria-label={this.props.i18n.getString('DoubleListBox_Back')}
        onClick={() => this.props.onClick(null)}
      >
        <Glyphicon glyph="chevron-left" />
      </Button>
    );
  }
}

ButtonBack.propTypes = {
  onClick: PropTypes.func.isRequired,
  className: PropTypes.string.isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
};
